module.exports = __webpack_public_path__ + "img/reward.2fa30d8a.svg";